<template>
  <b-row class="m-0">
    <b-container fluid
        :style="{ 'height': height, 'text-align': 'center' }"
        class="vld-parent white-box">
      <loading active color="#0BA7DA" :is-full-page="false"/>
    </b-container>
  </b-row>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  props: [
    'height'
  ]
}
</script>

<style>

</style>
